/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    MoyaComponents.register('store.order-datpicker', [
        'https://cdn.jsdelivr.net/npm/flatpickr@4.6.9/dist/flatpickr.min.js',
        'https://cdn.jsdelivr.net/npm/flatpickr@4.6.9/dist/flatpickr.min.css',
    ], function (el) {
        var parent = el.closest('.datepicker');
        var config = {
            parent: parent,
        };
        var datePicker = new DatePicker(config);
        datePicker.run();
    });
    var DatePicker = /** @class */ (function () {
        function DatePicker(config) {
            this.parent = config.parent;
        }
        DatePicker.prototype.run = function () {
            flatpickr(this.parent, {
                locale: this.getIcelandic(),
                dateFormat: 'Y-m-d',
                altInput: true,
                altFormat: "j. F",
                defaultDate: this.getMinDate(),
                minDate: this.getMinDate(),
                disable: [
                    // Disable weekends
                    function (date) {
                        return date.getDay() === 0 || date.getDay() === 6;
                    },
                ],
            });
            var ev = new Event('change');
            this.parent.dispatchEvent(ev);
        };
        DatePicker.prototype.getIcelandic = function () {
            return {
                weekdays: {
                    shorthand: ['Sun', 'Mán', 'Þri', 'Mið', 'Fim', 'Fös', 'Lau'],
                    longhand: [
                        'Sunnudagur',
                        'Mánudagur',
                        'Þriðjudagur',
                        'Miðvikudagur',
                        'Fimmtudagur',
                        'Föstudagur',
                        'Laugardagur',
                    ],
                },
                months: {
                    shorthand: [
                        'Jan',
                        'Feb',
                        'Mar',
                        'Apr',
                        'Maí',
                        'Jún',
                        'Júl',
                        'Ágú',
                        'Sep',
                        'Okt',
                        'Nóv',
                        'Des',
                    ],
                    longhand: [
                        'Janúar',
                        'Febrúar',
                        'Mars',
                        'Apríl',
                        'Maí',
                        'Júní',
                        'Júlí',
                        'Ágúst',
                        'September',
                        'Október',
                        'Nóvember',
                        'Desember',
                    ],
                },
                ordinal: function () {
                    return '.';
                },
                firstDayOfWeek: 1,
                rangeSeparator: ' til ',
                weekAbbreviation: 'vika',
                yearAriaLabel: 'Ár',
                time_24hr: true,
            };
        };
        DatePicker.prototype.getMinDate = function () {
            var now = new Date();
            for (var i = 1; i <= 6; i++) {
                now.setDate(now.getDate() + 1);
                if (now.getDay() === 6) {
                    now.setDate(now.getDate() + 2);
                }
                else if (now.getDay() === 0) {
                    now.setDate(now.getDate() + 1);
                }
            }
            return now;
        };
        return DatePicker;
    }());

}());
typeof tsBuild === 'function' && tsBuild();})();
